<template>
  <tg-dialog
    ref="dialog"
    v-bind="{ ...$attrs }"
    v-on="$listeners"
    :show-close="true"
    theme="info"
    :showIcon="false"
    width="50%"
    custom-class="tg-confirm-dialog"
    :visible.sync="visible"
    @on-confirm="handleConfirm"
    destroy-on-close
    showFooter
    append-to-body
    :confirmLabel="confirmLabel"
    :title="title"
  >
    <tg-form-table
      :columns="columns"
      :data.sync="tableData"
      :fenceRow="3"
      :fenceCol="1"
      :columnWidth="250"
      :cellWidth="400"
    >
      <template slot="password" slot-scope="scope">
        <el-row type="flex" justify="space-around">
          <el-input
            :placeholder="$t('component.form.input.placeholder.password[1]')"
            v-model="tableData[scope.column.name]"
            class="tg-input ma-l-2 col-10"
            size="small"
            type="password"
            clearable
          ></el-input>
        </el-row>
      </template>
      <template slot="cellphone">
        <el-row type="flex" justify="center">
          <el-row type="flex" justify="start" align="middle" class="col-10">
            <tg-dropdown
              :items="dropdown"
              @on-change="handleAreaChange"
              menuClass="cellphone-area"
            ></tg-dropdown>
            <el-input
              :placeholder="$t('component.form.input.placeholder.cellphone')"
              v-model="tableData.cellphone"
              class="tg-input"
              size="small"
              clearable
            ></el-input>
          </el-row>
        </el-row>
      </template>
      <template v-slot:sms>
        <el-row type="flex" justify="center" align="middle">
          <el-row type="flex" justify="start" align="middle" class="col-10">
            <el-input
              :placeholder="$t('component.form.input.placeholder.sms')"
              v-model="tableData.sms"
              class="tg-input ma-t-2"
              size="small"
              clearable
            ></el-input>
            <tg-button
              class
              fill
              theme="warning"
              round
              style="width: 150px"
              @click.native="handleSendSMS"
              :disabled="nextSendSMS > 0"
              >{{ sendSMSLabel }}</tg-button
            >
          </el-row>
        </el-row>
      </template>
    </tg-form-table>
  </tg-dialog>
</template>

<script>
import TgDialog from "@/components/dialog/TgDialog";
import TgFormTable from "@/components/table/TgFormTable";
import TgDropdown from "@/components/dropdown/TgDropdown";
import TgButton from "@/components/button/TgButton";

import apis from "@/apis";

export default {
  inheritAttrs: false,
  components: {
    TgDialog,
    TgFormTable,
    TgDropdown,
    TgButton,
  },
  data() {
    return {
      visible: false,
      dropdown: [],
      tableData: {},
      columns: [
        {
          name: "password",
          title: "密碼",
          langKey: "password",
          slot: "password",
          align: "left",
        },
        {
          name: "cellphone",
          title: "移動電話",
          langKey: "cellphone",
          slot: "cellphone",
          align: "left",
        },
        {
          name: "sms",
          title: "手機驗證",
          langKey: "sms",
          slot: "sms",
          align: "left",
        },
      ],
      nextSendSMS: 0,
      sec: "",
    };
  },
  computed: {
    confirmLabel() {
      return this.$t("component.btn.save");
    },
    title() {
      return this.$t("page.member.profile.registerMobile");
    },
    smsRequest() {
      return {
        phone: this.tableData.cellphone,
        area: this.tableData.area,
      };
    },
    registerRequest() {
      return this.tableData;
    },
    sendSMSLabel() {
      return this.$t("component.btn.sendSMS") + this.sec;
    },
  },
  created() {
    this.fetchDropdown();
  },
  methods: {
    fetchDropdown() {
      apis.dropdown.getCountryCode().then((response) => {
        this.dropdown = response.data.map(x => {
          x.label = this.$t(x.langKey);
          return x;
        });
        this.tableData.area = this.dropdown[0].value;
      });
    },
    show() {
      this.visible = true;
    },
    handleAreaChange(item) {
      this.tableData.area = item.value;
    },
    setIntervalSMS() {
      this.nextSendSMS -= 1;
      this.sec = this.nextSendSMS > 0 ? "(" + this.nextSendSMS + ")" : "";

      if (this.nextSendSMS <= 0) {
        clearInterval(this.setIntervalSMS);
      }
    },
    lockSendSMSBtn(sec) {
      this.nextSendSMS = sec;
      this.sec = sec > 0 ? "(" + sec + ")" : "";
      setInterval(this.setIntervalSMS, 1000);
    },
    handleSendSMS() {
      if (!this.tableData.cellphone || !this.tableData.area) {
        this.$message.warning(this.$t("message.error.required.cellphone"));
        return;
      }

      if(this.tableData.cellphone.length < 6 ){
        this.$message.warning(this.$t("enum.sms.statusCode[106]"));
        return;
      }

      apis.sms
        .sendRegisterSMS(this.smsRequest)
        .then(({ retcode, data, message }) => {
          if (retcode == 1) {
            this.lockSendSMSBtn(data.sec);
            this.$message.error(message);
          } else {
            this.lockSendSMSBtn(180);
            let msg = this.$t("message.success.sms");
            if (data.code) {
              msg += "[" + data.code + "]";
            }
            this.$message.success(msg);
          }
        });
    },
    validateForm() {
      let fields = ["password", "cellphone", "area", "sms"];
      let pass = true;

      fields.forEach((item) => {
        if (!this.tableData[item]) {
          pass = false;
        }
      });

      return pass;
    },
    handleConfirm() {
      if (!this.validateForm()) {
        this.$message.warning(this.$t("message.error.required.form"));
        return;
      }

      apis.member.action.registerMobile(this.registerRequest).then((response) => {
        if(response.retcode == 0){
          this.visible = false;
          this.$message.success(this.$t("page.member.profile.register.success"));
          location.reload();
        }else{
          this.$message.error(this.$t("statusCode["+response.retcode+"]"));
        }
        
      });
    },
  },
  watch: {
    visible() {
      this.tableData = {
        area: this.dropdown[0].value,
      };
    },
  },
};
</script>
